import { useRecoilValue } from "recoil";
import { getCurrentContent } from "selectors/controller";
import ReactHTMLParser from "react-html-parser";

const Intro: React.FC = () => {
  const content = useRecoilValue(getCurrentContent);
  return (
    <p className="text-gray-900 text-justify leading-loose dark:text-gray-200">
      {ReactHTMLParser(content.description)}
    </p>
  );
};

export default Intro;
